// We disable `import/no-mutable-exports` temporarily because we need to support
// changing server live by ab test change. It's bad thing to do which causing
// unwanted side-effects and disable many optimizations
/* eslint-disable import/no-mutable-exports */
/**
 * Settings - 2
 * @module @anydo/core
 */

//#region Imports
import { ExternalProviderT, TeamsPlanPeriod } from "@anydo/interfaces";
import { getAppVersion } from "../utils/env/getAppVersion";
import { getBrowserDetails } from "../utils/env/getBrowserDetails";
import { getOsDetails } from "../utils/env/getOsDetails";
import {
  ANALYTICS_APP_PLATFORM_MAC_APP,
  ANALYTICS_APP_PLATFORM_WEB_APP,
  ANALYTICS_APP_PLATFORM_WEB_EXTENSION,
} from "./constants";
//#endregion

//#region Server config
// const SM_DEV = "sm-dev3.any.do";
const API_HOST_DEV = "sm-dev-teams.any.do"; // TODO: temporary till teams dev server is live https://anydo1.atlassian.net/browse/WEB4-346
const API_HOST_STAGING = "sm-prod-teams.any.do";
const API_HOST_PROD = "sm-prod4.any.do";
// const WS_DEV = "ws-dev3.any.do";
const WS_DEV = "ws-dev3teams.any.do"; // TODO: temporary till teams dev server is live https://anydo1.atlassian.net/browse/WEB4-346
const WS_STAGING = "ws-prod3teams.any.do";
const WS_PROD = "ws-prod4.any.do";
//#endregion
const THUMBNAIL_SERVER_DEV = "thumb-server-dev.any.do";
const THUMBNAIL_SERVER_PROD = "thumb-server.any.do";

export const ABSERVICE_URL = "https://abservice3.any.do/xABService/me";

export const CALENDLY_LINK = "https://calendly.com/perchik/20min";

//#region Any.do API server / Sync server
/**
 * Yoni's debug URL "https://yoni.ngrok.io"
 *
 * @example
 * const SETTINGS_API_ORIGIN_URL = "https://yoni.ngrok.io";
 * const SETTINGS_WEBSOCKET_URL = createSettingsWebSocketUrl(true, API_HOST_DEV, -1);
 */
let { SETTINGS_API_ORIGIN_URL, SETTINGS_WEBSOCKET_URL, SETTINGS_THUMBNAIL_SERVER_URL } = getSettingsApiOrigin();
export { SETTINGS_API_ORIGIN_URL, SETTINGS_WEBSOCKET_URL, SETTINGS_THUMBNAIL_SERVER_URL };

export const AUTH_HEADER = "X-Anydo-Auth";
//#endregion

//#region Auth specific
export let SETTINGS_AUTH_LOGIN_URL = SETTINGS_API_ORIGIN_URL + "/login";
export let SETTINGS_AUTH_PRE_2FA_LOGIN_URL = SETTINGS_API_ORIGIN_URL + "/login-2fa";
export let SETTINGS_AUTH_LOGIN_2FA = SETTINGS_API_ORIGIN_URL + "/login-2fa-code";

export let SETTINGS_AUTH_LOGOUT_URL = SETTINGS_API_ORIGIN_URL + "/j_spring_security_logout";
export let SETTINGS_AUTH_FACEBOOK_LOGIN_URL = SETTINGS_API_ORIGIN_URL + "/fb-login";
export let SETTINGS_AUTH_GOOGLE_LOGIN_URL = SETTINGS_API_ORIGIN_URL + "/google-login";
export let SETTINGS_AUTH_APPLE_LOGIN_WEB_REDIRECT_URL = SETTINGS_API_ORIGIN_URL + "/apple-login-web-redirect";
export let SETTINGS_AUTH_APPLE_LOGIN_URL = SETTINGS_API_ORIGIN_URL + "/apple-login";
export let SETTINGS_AUTH_USER_URL = SETTINGS_API_ORIGIN_URL + "/user";
export let SETTINGS_AUTH_CHANGE_EMAIL_URL = SETTINGS_API_ORIGIN_URL + "/user/change-email";
export let SETTINGS_AUTH_ME_URL = SETTINGS_API_ORIGIN_URL + "/me";
export let SETTINGS_AUTH_CHECK_EMAIL_URL = SETTINGS_API_ORIGIN_URL + "/check_email";
export let SETTINGS_AUTH_FORGOT_PASSWORD_URL = SETTINGS_API_ORIGIN_URL + "/send-forgot-password-email";
export let SETTINGS_AUTH_REQUEST_S3_UPLOAD_URL = SETTINGS_API_ORIGIN_URL + "/me/request_s3_presigned_post";
export let SETTINGS_AUTH_ONBOARDING_COMPLETE_URL = SETTINGS_API_ORIGIN_URL + "/me/on-boarding-completed";
export let SETTINGS_AUTH_START_TRACKING_COMPLETED_TASKS_URL =
  SETTINGS_API_ORIGIN_URL + "/me/start-tracking-completed-tasks";
//#endregion

//#region Auth WhatsApp
export let SETTINGS_AUTH_SEND_PHONE_VERIFICATION_URL = SETTINGS_API_ORIGIN_URL + "/me/add-phone";
export let SETTINGS_AUTH_SEND_PHONE_REMOVAL_URL = SETTINGS_API_ORIGIN_URL + "/me/remove-phone";
export let SETTINGS_AUTH_VALIDATE_SMS_CODE_URL = SETTINGS_API_ORIGIN_URL + "/me/validate-sms-code";
export let SETTINGS_AUTH_UPDATE_WHATSAPP_URL = SETTINGS_API_ORIGIN_URL + "/me/update-whatsapp";
export let SETTINGS_AUTH_ENABLE_WHATSAPP_URL = SETTINGS_API_ORIGIN_URL + "/me/enable-whatsapp";
export let SETTINGS_AUTH_DISABLE_WHATSAPP_URL = SETTINGS_API_ORIGIN_URL + "/me/disable-whatsapp";
export let SETTINGS_AUTH_UPDATE_WHATSAPP_WORKSPACE_URL = SETTINGS_API_ORIGIN_URL + "/me/update-whatsapp-workspace";
export let SETTINGS_AUTH_ENABLE_WHATSAPP_WORKSPACE_URL = SETTINGS_API_ORIGIN_URL + "/me/enable-whatsapp-workspace";
export let SETTINGS_AUTH_DISABLE_WHATSAPP_WORKSPACE_URL = SETTINGS_API_ORIGIN_URL + "/me/disable-whatsapp-workspace";
//#endregion

//#region Premium
export let SETTINGS_PREMIUM_STATUS_URL = SETTINGS_API_ORIGIN_URL + "/api/v1/subscription/latest";
export let SETTINGS_SUBSCRIPTION_URL = SETTINGS_API_ORIGIN_URL + "/api/v1/subscription";
//#endregion

//#region Business
export let SETTINGS_BUSINESS_URL = `${SETTINGS_API_ORIGIN_URL}/business`;
//#endregion

//#region Sync specific
export const SETTINGS_SYNC_VERSION = 14;
const SYNC_VERSION = `v${SETTINGS_SYNC_VERSION}`;
export const SETTINGS_REST_SYNC_URL = `${SETTINGS_API_ORIGIN_URL}/api/${SYNC_VERSION}/me/sync`;
export const SETTINGS_REST_BG_SYNC_URL = `${SETTINGS_API_ORIGIN_URL}/api/${SYNC_VERSION}/me/bg_sync`;
export const SETTINGS_REST_BG_SYNC_RESULT_URL = `${SETTINGS_API_ORIGIN_URL}/me/bg_sync_result`;
export const SETTINGS_REST_SYNC_TIMEOUT = 30000;
export const SETTINGS_WEBSOCKET_SYNC_URL = SETTINGS_WEBSOCKET_URL;
export const SETTINGS_WEBSOCKET_SYNC_APP_IDLE_TIMEOUT = 3 * 60 * 1000; // 3 minutes
//#endregion

//#region Any.do - Application platform
/**
 * `3` is for web. Mainly used for X-Platform header
 */
export const SETTINGS_APP_PLATFORM: 2 | 3 | 4 | 5 =
  process.env.REACT_APP_PLATFORM_TYPE === "electron" ? ANALYTICS_APP_PLATFORM_MAC_APP
  : typeof chrome !== "undefined" && chrome.runtime && chrome.runtime.id != null ? ANALYTICS_APP_PLATFORM_WEB_EXTENSION
  : ANALYTICS_APP_PLATFORM_WEB_APP;
//#endregion

export const SETTINGS_PRODUCT_WHATS_NEW_URL = "https://blogdh.any.do/web-whats-new/";

//#region Teams integration api endpoint
export const TEAMS_INTEGRATION_API_URL =
  __ANYDO_ENV_DEV__ ? "https://teams-integrations-dev.any.do" : "https://teams-integrations.any.do";
//#endregion

//#region Trello
const TRELLO_RETURN_URL = `${TEAMS_INTEGRATION_API_URL}/auth/redirect/trello`;
const TRELLO_OAUTH_KEY = "99080f2913fb8917262222d89ed3bb1d";
export const TRELLO_OAUTH_URL = `https://api.trello.com/1/authorize?scope=read&expiration=never&name=Any.do&key=${TRELLO_OAUTH_KEY}&response_type=fragment&return_url=${TRELLO_RETURN_URL}`;
//#endregion

//#region Asana
const ASANA_RETURN_URL = `${TEAMS_INTEGRATION_API_URL}/auth/redirect/asana`;
const ASANA_CLIENT_ID = "1200435460512877";
export const ASANA_OAUTH_URL = `https://app.asana.com/-/oauth_authorize?response_type=code&client_id=${ASANA_CLIENT_ID}&redirect_uri=${ASANA_RETURN_URL}`;
//#endregion

//#region Clickup
const CLICKUP_RETURN_URL = `${TEAMS_INTEGRATION_API_URL}/auth/redirect/clickup`;
const CLICKUP_CLIENT_ID = "A2D5RS1M3IN4KQ7AAYE6C7EBCC56FXUX";
export const CLICKUP_OAUTH_URL = `https://app.clickup.com/api?client_id=${CLICKUP_CLIENT_ID}`;
//#endregion

//#region Monday
const MONDAY_RETURN_URL = `${TEAMS_INTEGRATION_API_URL}/auth/redirect/monday`;
const MONDAY_CLIENT_ID = "822f288c8f88eb09d1fbf4672f5dbffe";
export const MONDAY_INSTALL_URL =
  "https://auth.monday.com/oauth2/authorize?client_id=822f288c8f88eb09d1fbf4672f5dbffe&response_type=install";
export const MONDAY_OAUTH_URL = `https://auth.monday.com/oauth2/authorize?client_id=${MONDAY_CLIENT_ID}&redirect_uri=${MONDAY_RETURN_URL}`;
//#endregion

//#region Todoist
const TODOIST_CLIENT_ID = __ANYDO_ENV_DEV__ ? "106a3eb9d8644e668566518f1b7748bc" : "45e908adde904f55b6c690ab3b616162";
export const TODOIST_OAUTH_URL = `https://todoist.com/oauth/authorize?client_id=${TODOIST_CLIENT_ID}&scope=data:read`;
//#endregion

//#region Jira
const JIRA_CLIENT_ID = __ANYDO_ENV_DEV__ ? "aksYENlv6OxRNAS4Y6rY9sTcUMnnjrAe" : "rSNxY3qjF5reyWvm1uTB7As6mwtYiHWt";
const JIRA_RETURN_URL = `${TEAMS_INTEGRATION_API_URL}/auth/redirect/jira`;
export const JIRA_OAUTH_URL = `https://auth.atlassian.com/authorize?audience=api.atlassian.com&client_id=${JIRA_CLIENT_ID}&scope=read:jira-work%20read:jira-user%20read%3Ame%20offline_access&redirect_uri=${JIRA_RETURN_URL}&response_type=code&prompt=consent`;
//#endregion

//#region Intercom
export const SETTINGS_INTERCOM_APP_ID = "yqcgcpu0";
//#endregion

export const FAMILY_GROCERY_BOARD_TEMPLATE_ID = "family_templates/en__home_projects.json";

export const getExternalProviderOAuthUrl = (provider: ExternalProviderT, taskId: string) => {
  switch (provider) {
    case "trello":
      return TRELLO_OAUTH_URL + `?task_id=${encodeURIComponent(taskId)}&scopes=read&exp=never`;
    case "asana":
      return ASANA_OAUTH_URL + `&state=${encodeURIComponent(`task_id=${taskId}`)}`;
    case "clickup":
      return CLICKUP_OAUTH_URL + `&redirect_uri=${encodeURIComponent(`${CLICKUP_RETURN_URL}?task_id=${taskId}`)}`;
    case "monday":
      return MONDAY_OAUTH_URL + `&state=${encodeURIComponent(`task_id=${taskId}`)}`;
    case "todoist":
      return TODOIST_OAUTH_URL + `&state=${encodeURIComponent(`task_id=${taskId}&scope=data:read`)}`;
    case "jira":
      return JIRA_OAUTH_URL + `&state=${encodeURIComponent(`task_id=${taskId}`)}`;
  }
};

export function getContactFormUrl(name: string, email: string, topic?: "bug" | "billing" | "sales") {
  const search = new URLSearchParams();
  search.set("platform", "web");
  if (topic) {
    search.set("type", topic);
  }
  search.set("fullname", name);
  search.set("email", email);
  search.set("browser", getBrowserDetails());
  search.set("os", getOsDetails());
  search.set("version", getAppVersion());

  return `https://www.any.do/contact_form?${search.toString()}`;
}

//#region Kensis
export const SETTINGS_KINESIS_IDENTITY_POOL_ID =
  __ANYDO_ENV_DEV__ || Boolean(process.env.STORYBOOK_STORYBOOK) ?
    // spellchecker:disable-next-line
    "us-east-1:de56b769-c17e-4f51-8851-9b989cce8e1b" // test;
    // spellchecker:disable-next-line
  : "us-east-1:6edc2b00-06c6-4f02-ba3d-6b56f015e0b1"; // prod

export const SETTINGS_KINESIS_STREAM_NAME =
  __ANYDO_ENV_DEV__ || Boolean(process.env.STORYBOOK_STORYBOOK) ? "events-dev" : "events-prod";
//#endregion

//#region Facebook
export const SETTINGS_FACEBOOK_APP_ID = "218307504870310";
export const SETTINGS_FACEBOOK_PERMISSIONS = "email,public_profile";
//#endregion

//#endregion

//#region Google
export const SETTINGS_GOOGLE_NATIVE_CLIENT_ID_LOCALHOST_AUTH = "543675644531-3ai1t05lhg6q15g5370bb33r37nk5g4l.apps.googleusercontent.com"; // prettier-ignore

// spellchecker:disable-next-line
export const SETTINGS_GOOGLE_NATIVE_CLIENT_ID = "543675644531-vufis5g05c5sovb466r8ncq30a9rg4em.apps.googleusercontent.com"; // prettier-ignore
export const SETTINGS_GOOGLE_NATIVE_CLIENT_CUSTOM_SCHEME =
  "com.googleusercontent.apps.543675644531-vufis5g05c5sovb466r8ncq30a9rg4em";

// spellchecker:disable-next-line
export const SETTINGS_GOOGLE_APP_ID = "543675644531";
export const SETTINGS_GOOGLE_CLIENT_ID = `${SETTINGS_GOOGLE_APP_ID}-gmep88fhv3nkbmf2ivsn5t48el7f3ra6.apps.googleusercontent.com`;

export const SETTINGS_GOOGLE_RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_PLATFORM_TYPE === "electron" ?
    "6LfVOVAiAAAAACXsOLIpq8XYy2YwHCyHdKmJHm4i"
  : "6LeEJH0fAAAAAJhe16P0fbKeTOn1cGtyG5Q-XtCf";

export enum GoogleRecaptchaAction {
  EmailRegistration = "email_registration",
  FormSubmission = "form_submission",
}

export const SETTINGS_GOOGLE_LOOPBACK_PORT = 8765;

export const MICROSOFT_OAUTH_SETTINGS = {
  clientId: __ANYDO_ENV_DEV__ ? "511d0541-e20c-4319-80bb-a65c125b8fd0" : "bf12a03f-3d2b-42f6-ac11-9aee2c0ad5bc",
  calendarRedirectUriSegment: `oauth-results/microsoft-calendar`,
  electronRedirectUri: `http://localhost:${SETTINGS_GOOGLE_LOOPBACK_PORT}`,
  electronRedirectUriPort: SETTINGS_GOOGLE_LOOPBACK_PORT,
  electronMasScheme: `msauth.com.anydo.mac`,
  scopes: [
    "Calendars.ReadWrite",
    "offline_access",
    "Calendars.ReadWrite.Shared",
    "openid",
    "profile",
    "User.Read",
    "People.Read",
  ],
  calendarEndpoint: `https://graph.microsoft.com/v1.0/me/calendars?top=999&$select=id,name,color,hexColor,owner,canEdit,canShare,isDefaultCalendar`,
  codeChallenge: "ULioy4D2Ml9V6C6mU-G6i9BL_4WoG9a11xInRNIDSTw",
  codeChallengeMethod: "S256",
};

export const BOX_CLIENT_ID = "psa145rq7hf3zh63ygkf4sfgr11anyyf";

export const DROPBOX_APP_KEY = "be3yrjq683ya9i3";

export const ZOOM_CLIENT_ID = __ANYDO_ENV_DEV__ ? "7RWcpjWTQSlFCoi63N4Iw" : "CtSfQxz9QGaMYYppHk_KdQ";

/**
 * It's the key for both Electron and Web. `SETTINGS_GOOGLE_NATIVE_CLIENT_ID`
 * returns invalid API key error from Google, But the Web keys works
 */
export const SETTINGS_GOOGLE_CALENDAR_API_KEY = SETTINGS_GOOGLE_CLIENT_ID;

//#endregion

//#region Stripe
export const SETTINGS_STRIPE_KEY =
  __ANYDO_ENV_DEV__ || Boolean(process.env.STORYBOOK_STORYBOOK) ?
    // spellchecker:disable-next-line
    "pk_test_ibci0S0N18vCEROPRoY786nk" // test;
    // spellchecker:disable-next-line
  : "pk_live_PpUdKgmIH1mJ388r4uOIqJPb"; // prod
//#endregion

//#region Any.do API server - Setup
function getSettingsApiOrigin() {
  let SETTINGS_API_ORIGIN_URL;
  let SETTINGS_WEBSOCKET_URL;
  let SETTINGS_THUMBNAIL_SERVER_URL;

  if (process.env.NODE_ENV === "test") {
    // Test environment

    SETTINGS_API_ORIGIN_URL = createSettingsApiOriginUrl(false, "localhost", 22302);
    SETTINGS_WEBSOCKET_URL = createSettingsWebSocketUrl(false, "localhost", 22301);
  } else if (__ANYDO_ENV_DEV__) {
    // Development server
    SETTINGS_API_ORIGIN_URL = createSettingsApiOriginUrl(true, API_HOST_DEV, -1);
    SETTINGS_WEBSOCKET_URL = createSettingsWebSocketUrl(true, WS_DEV, -1);
    SETTINGS_THUMBNAIL_SERVER_URL = createSettingsThumbnailServerOriginUrl(true, THUMBNAIL_SERVER_DEV, -1);
  } else if (__ANYDO_ENV_STAGING__) {
    // Staging server
    SETTINGS_API_ORIGIN_URL = createSettingsApiOriginUrl(true, API_HOST_STAGING, -1);
    SETTINGS_WEBSOCKET_URL = createSettingsWebSocketUrl(true, WS_STAGING, -1);
    SETTINGS_THUMBNAIL_SERVER_URL = createSettingsThumbnailServerOriginUrl(true, THUMBNAIL_SERVER_PROD, -1);
  } else {
    // Production server
    SETTINGS_API_ORIGIN_URL = createSettingsApiOriginUrl(true, API_HOST_PROD, -1);
    SETTINGS_WEBSOCKET_URL = createSettingsWebSocketUrl(true, WS_PROD, -1);
    SETTINGS_THUMBNAIL_SERVER_URL = createSettingsThumbnailServerOriginUrl(true, THUMBNAIL_SERVER_PROD, -1);
  }

  return {
    SETTINGS_API_ORIGIN_URL: process.env.VITE_API_ORIGIN_URL ?? SETTINGS_API_ORIGIN_URL,
    SETTINGS_WEBSOCKET_URL: process.env.VITE_WEBSOCKET_URL ?? SETTINGS_WEBSOCKET_URL,
    SETTINGS_THUMBNAIL_SERVER_URL,
  };
}

function createSettingsApiOriginUrl(ssl: boolean, domain: string, port: number) {
  const URL_PORT = port !== -1 ? `:${port}` : "";
  return `http${ssl ? "s" : ""}://${encodeURIComponent(domain)}${URL_PORT}`;
}

function createSettingsWebSocketUrl(ssl: boolean, domain: string, port: number) {
  const WS_URL_PORT = port !== -1 ? `:${port}` : "";
  return `ws${ssl ? "s" : ""}://${encodeURIComponent(domain)}${WS_URL_PORT}`;
}

function createSettingsThumbnailServerOriginUrl(ssl: boolean, domain: string, port: number) {
  const URL_PORT = port !== -1 ? `:${port}` : "";
  return `http${ssl ? "s" : ""}://${encodeURIComponent(domain)}${URL_PORT}`;
}

//#endregion

//#region subscription plan settings
export const TEAMS_PLAN_TRIAL_PERIOD = 14; // days
export const TEAMS_PLAN_TRIAL_EXTENSION_PERIOD = 7; // days

export const NOTIFY_PAYMENT_METHOD_EXPIRATION_DAYS_AHEAD = 60; // days
export const NOTIFY_PLAN_EXPIRATION_DAYS_AHEAD = 30; // days
//#endregion

export const ONBOARDING_DEFAULT_PLAN_PERIOD = TeamsPlanPeriod.YEAR;

export const ON_PAYMENT_CONFIRMED_CLOSE_DELAY = 2000;

export const LIFETIME_PLANS = {
  // Prime Club
  PRIME_FIRST_5_FREE_PLAN_ID: "prime_ws_first_5_free",
  PRIME_FIRST_8_FREE_PLAN_ID: "prime_ws_first_8_free",

  // AppSumo
  APPSUMO_FIRST_1_FREE: "appsumo_ws_first_1_free",
  APPSUMO_FIRST_3_FREE: "appsumo_ws_first_3_free",
  APPSUMO_FIRST_5_FREE: "appsumo_ws_first_5_free",
} as const;

export const GOOGLE_PLACES_KEY = "AIzaSyC2_QlC2bKJXCIKaRVyKl3ZusrEGT2M04M";

export const SW_MESSAGE_NOTIFICATION = "anydo:NOTIFICATION";
export const SW_MESSAGE_PUSH = "anydo:PUSH";

export const GOOGLE_WORKSPACE_MEET_CLOUD_PROJECT_NUMBER = "440640352922";

export const EXTERNAL_BOARD_APP_ORIGIN = __ANYDO_ENV_DEV__ ? "https://forms-dev.any.do" : "https://forms.any.do";
